import React, { useState } from 'react';
import { Modal, Slider, InputNumber, Row, Col, Button, Typography, Space } from 'antd';
import { useTranslationWithNamespace } from '../../hooks/useTranslationWithNamespace';

const { Text } = Typography;

interface GasPriceMultiplierModalProps {
  visible: boolean;
  onCancel: () => void;
  onConfirm: (gasPriceMultiplier: number) => void;
  title: string;
  description: string;
  confirmText: string;
  isLoading: boolean;
}

const GasPriceMultiplierModal: React.FC<GasPriceMultiplierModalProps> = ({
  visible,
  onCancel,
  onConfirm,
  title,
  description,
  confirmText,
  isLoading
}) => {
  const { t } = useTranslationWithNamespace('transactions');
  const [gasPriceMultiplier, setGasPriceMultiplier] = useState<number>(1.5);

  const handleGasPriceChange = (value: number | null) => {
    if (value !== null) {
      setGasPriceMultiplier(value);
    }
  };

  const handleConfirm = () => {
    onConfirm(gasPriceMultiplier);
  };

  return (
    <Modal
      title={title}
      open={visible}
      onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={onCancel}>
          {t('actions.cancel', 'Cancel')}
        </Button>,
        <Button
          key="confirm"
          type="primary"
          onClick={handleConfirm}
          loading={isLoading}
        >
          {confirmText}
        </Button>
      ]}
    >
      <p>{description}</p>
      <p>
        {t('speedUp.feeIncrease', 'Fee Increase')}:
      </p>
      <Row gutter={16}>
        <Col span={16}>
          <Slider
            min={1.1}
            max={5}
            step={0.1}
            value={gasPriceMultiplier}
            onChange={handleGasPriceChange}
          />
        </Col>
        <Col span={8}>
          <InputNumber
            min={1.1}
            max={5}
            step={0.1}
            value={gasPriceMultiplier}
            onChange={handleGasPriceChange}
            style={{ width: '100%' }}
          />
        </Col>
      </Row>
      <Space direction="vertical" style={{ marginTop: 16 }}>
        <Text type="secondary">
          {t('speedUp.multiplierExplanation', 'A multiplier of 1.5 means the gas price will be 50% higher than the original transaction.')}
        </Text>
        <Text type="secondary">
          {t('speedUp.rangeExplanation', 'You can set a multiplier between 1.1x and 5x.')}
        </Text>
      </Space>
    </Modal>
  );
};

export default GasPriceMultiplierModal;
